export default {
    values: {
        'Data Aggregations': 'Agregações de dados',
        Reprocess: 'Reprocessar',
        Start: 'Iniciar',
        'Start (Select Timespan)': 'Iniciar (Seleção de Timespan)',
        'Start (no reprocess)': 'Iniciar (sem reprocessamento)',
        'Start': 'Iniciar',
        Stop: 'Parar',
        Name: 'Nome',
        'Latest event': 'Último evento',
        Status: 'Status',
        Rebuilding: 'Reprocessando',
        Running: 'Em execução',
        Stopped: 'Parado',
        Error: 'Erro',
        Loading: 'Carregando',
        'Waiting on queue': 'Aguardando na fila',
        'No aggregations configured': 'Nenhuma agregação configurada',
        'Data management is disabled for this asset; please enable it in order to display and manage the aggregations':
            'A gestão de dados está desativada para este ativo. Por favor, habilite para exibir e gerenciar as agregações',
        'Choose reprocessing span': 'Insira o período de reprocessamento',
        'If no span is entered, "none" will be used as default':
            'Se o período de reprocessamento não for informado, "none" será utilizado como padrão',
        'If no span is entered, we will assume "None". If a span is entered before the last event it will reprocess from that time.':
            'Se nenhum span for posto, será assumido o valor "none". Se o valor do span for anterior ao último evento, os eventos desse intervalo também serão reprocessados',
        or: 'ou',
        cancel: 'cancelar',
        'Warning: Span is blank, no data will be reprocessed.': 'Aviso: Span está vazio! Nenhum dado será reprocessado.',
        'Stopping Query...': 'Parando Query...',
        "The setting will only be applied after asset-aggregator restart": "Essa configuração só será efetivada após o reinício do plugin-asset-aggregator.",
        "Asset Aggregator Settings": "Configurações do Asset Aggregator",
        'Settings successfully saved': "Configuração salva com sucesso.",
        'Failed to save settings': "Falha em salvar configurações.",
        'Aggregator Configuration settings successfully saved': "Configurações do Asset Aggregator salvas com sucesso!",
        'Checkpoint Update Interval': "Intervalo de Atualização do Checkpoint",
        "It's recommended this setting to never be bellow 60000 (60 seconds) as the lower the number greater the chance SQL may be flooded.":
        "É recomendado manter essa configuração acima de 60000 (60 segundos) já que quanto menor o número mais estresse no SQL.",
        "Minimum duration of eventLobby.enter for logging": "Duração mínima para logar a passagem pelo lobby.enter",
        "Minimum duration of eventLobby.enter so we log this as a (bad) performance event. Recommended to be always above 100.":
        "Duração mínima para logarmos esse tempo como uma evidência de baixa performance. É recomendado manter o valor acima de 100.",
        'Minimum duration of controlEvent for logging': "Duração mínima do código do controlEvent para log",
        "Minimum duration of controlEvent so we log this as a (bad) performance event. Recommended to be always above 10.":
        "Duração mínima do código do controlEvent para logar esse evento como um evento de baixa performance. Recomendado sempre ser maior do que 10.",
        'Listener Configuration': "Configuração do Listener",
        'Executor Configuration': "Configuração do Executor",
        'Report Configuration': "Configuração de Report (Log)",
        'Debug Log Enabled': "Log de depuração habilitado",
        'Will output debug information on the __asset_aggregator stream.':
        "Vai soltar eventos de depuração na stream __asset_aggregator.",
        'Debug Log Save to Storage': "Salvar log de depuração no Storage",
        'Will save the debug events in the stream to the storage.':"Vai salvar os eventos de depuração no Storage.",
        'Performance Log Enabled': "Habilitar Log de Performance",
        "Will output performance information on the __asset_aggregator stream.":
        "Vai retornar os eventos de performance na stream __asset_aggregator.",
        'Performance Log Save to Storage': "Salvar log de performance no Storage",
        'Will save the performance events in the stream to the storage.':
        "Vai salvar os logs de performance na stream para o storage.",
        'This request will, by default, use the timezone that the system understand as yours. If more precision is needed use either timestamps or set the specific timezone you want to use.':
        "Essa requisição vai, por padrão, usar o fuso que o sistema entende como a sua. Se precisar de uma precisão maior, por favor use timestamps ou defina o fuso específico que deve ser usado."
    }
}
